var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthsudan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0639 7.3478C21.2466 3.03103 16.9776 0 12 0C8.68625 0 5.68657 1.34339 3.51514 3.51511L6.52029 7.3478H23.0639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55437 16.6087L3.51514 20.4849C5.68657 22.6566 8.68625 24 12 24C16.9944 24 21.2756 20.9487 23.0824 16.6087H6.55437Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6087 8.8261V15.1304H23.5867C23.8558 14.1324 24 13.0831 24 12C24 10.9012 23.852 9.8371 23.5753 8.8261H2.6087Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51469C-1.17157 8.20097 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90871 9.0165L5.37332 11.0603L7.76994 10.2988L6.2788 12.3235L7.74341 14.3674L5.3571 13.5749L3.86591 15.5995L3.88232 13.085L1.49591 12.2924L3.89235 11.5309L3.90871 9.0165Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthsudan);
export default __webpack_public_path__ + "static/media/southsudan.26ae823cd58ab0130e0e9346c880fb95.svg";
export { ForwardRef as ReactComponent };